import Vue from "vue";
import store from "@/vuex/store";
import storeself from "@/store";
import Router from "vue-router";

const Home = () => import("@/components/Home");
const mobileHome = () => import("@/view/Home");

// 懒加载方式，当路由被访问的时候才加载对应组件
const Index = () => import("@/components/Index");
const Login = () => import("@/components/login");
const Register = () => import("@/components/register");
const Infoindex = () => import("@/components/info/index");
const Changepswd = () => import("@/components/info/changepswd");
const Info = () => import("@/components/info/Info");
const Infoproductdetails = () => import("@/components/info/productdetails");
const InfoproductPublish = () => import("@/components/info/productPublish");
const Inforequiresdetails = () => import("@/components/info/Requiresdetails");
const InforequiresPublish = () => import("@/components/info/RequiresPublish");

const Fuwuliucheng = () => import("@/components/fuwuliucheng/index");

const AchievementSearch = () => import("@/components/achievement/index");
const Supplier = () => import("@/components/supplier/index");
const Achievementdetails = () => import("@/components/achievement/achievementdetails");
const Requirement = () => import("@/components/requirement/index");
const Assess = () => import("@/components/requirement/assess");
const Service = () => import("@/components/service/index");

const fufangyun = () => import("@/components/assessList/fufangyun");
const chuangxin = () => import("@/components/assessList/chuangxin");
const shuzhi = () => import("@/components/assessList/shuzhi");
const Trzfw = () => import("@/components/trzfw/index");
const Yingxiao = () => import("@/components/yingxiao/index");

const Drugaudit = () => import("@/components/drugaudit/index");
const Drugauditdetails = () => import("@/components/drugaudit/details");
const ConferenceMessage = () => import("@/components/ConferenceMessage/index");
const ConferenceMessagedetails = () => import("@/components/ConferenceMessage/details");
const Technology = () => import("@/components/technology/index");
const Technologydetails = () => import("@/components/technology/details");
const Invest = () => import("@/components/invest/index");
const Investdetails = () => import("@/components/invest/details");

const Manufacture = () => import("@/components/manufacture/index");

const ProductPublish = () => import("@/components/requirement/productPublish");
const Productdetails = () => import("@/components/requirement/productdetails");
const Productevaluate = () => import("@/components/requirement/productevaluate");
const ProductInquiry = () => import("@/components/requirement/productInquiry");
const RequiresPublish = () => import("@/components/requirement/requiresPublish");
const Requiresdetails = () => import("@/components/requirement/requiresdetails");
const Requiresevaluate = () => import("@/components/requirement/requiresevaluate");
const RequiresInquiry = () => import("@/components/requirement/RequiresInquiry");

const Forgetpassword = () => import("@/components/forgetpassword");


/*const NewList = () => import("@/components/system/newList");
const DemandList = () => import("@/components/system/demandList");
const AddDemand = () => import("@/components/system/addDemand");
const FilingsList = () => import("@/components/system/filingsList");
const FilingsView = () => import("@/components/system/filingsView");
const NewsView = () => import("@/components/system/newsView");*/


const mobileIndex = () => import("@/view/index");
const mobileLogin = () => import("@/view/login");
const mobileRegister = () => import("@/view/register");
const mobileInfoindex = () => import("@/view/info/index");
const mobileChangepswd = () => import("@/view/info/changepswd");
const mobileInfo = () => import("@/view/info/Info");
const mobileInfoproductdetails = () => import("@/view/info/productdetails");
const mobileInfoproductPublish = () => import("@/view/info/productPublish");
const mobileInforequiresdetails = () => import("@/view/info/Requiresdetails");
const mobileInforequiresPublish = () => import("@/view/info/RequiresPublish");



const mobileAchievementSearch = () => import("@/view/achievement/index");
const mobileAchievementdetails = () => import("@/view/achievement/achievementdetails");
const mobileRequirement = () => import("@/view/requirement/index");
const mobileAssess = () => import("@/view/requirement/assess");
const mobileService = () => import("@/view/service/index");

const mobileYingxiao = () => import("@/view/yingxiao/index");

const mobileDrugaudit = () => import("@/view/drugaudit/index");
const mobileDrugauditdetails = () => import("@/view/drugaudit/details");
const mobileConferenceMessage = () => import("@/view/ConferenceMessage/index");
const mobileConferenceMessagedetails = () => import("@/view/ConferenceMessage/details");
const mobileTechnology = () => import("@/view/technology/index");
const mobileTechnologydetails = () => import("@/view/technology/details");
const mobileInvest = () => import("@/view/invest/index");
const mobileInvestdetails = () => import("@/view/invest/details");

const mobileManufacture = () => import("@/view/manufacture/index");

const mobileProductPublish = () => import("@/view/requirement/productPublish");
const mobileProductdetails = () => import("@/view/requirement/productdetails");
const mobileProductevaluate = () => import("@/view/requirement/productevaluate");
const mobileProductInquiry = () => import("@/view/requirement/productInquiry");
const mobileRequiresPublish = () => import("@/view/requirement/requiresPublish");
const mobileRequiresdetails = () => import("@/view/requirement/requiresdetails");
const mobileRequiresevaluate = () => import("@/view/requirement/requiresevaluate");
const mobileRequiresInquiry = () => import("@/view/requirement/RequiresInquiry");

const mobileForgetpassword = () => import("@/view/forgetpassword");

Vue.use(Router);

let router = new Router({
    // mode: 'history',
    //base: 'admin',
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
            redirect: "/index",
            leaf: true, // 只有一个节点
            meta: { menuShow: true },
            iconCls: "fa fa-home", // 图标样式class
            children: [
                {
                    path: "/index",
                    component: Index,
                    name: "首页",
                    meta: { menuShow: true }
                },
                {
                    path: "/login",
                    component: Login,
                    name: "登录",
                    meta: { menuShow: true }
                },
                {
                    path: "/forgetpassword",
                    component: Forgetpassword,
                    name: "忘记密码",
                    meta: { menuShow: true }
                },
                {
                    path: "/register",
                    component: Register,
                    name: "注册",
                    meta: { menuShow: true }
                },



                {
                    path: "/supplier",
                    component: Supplier,
                    name: "服务商",
                    meta: { menuShow: true }
                },
                {
                    path: "/trzfw",
                    component: Trzfw,
                    name: "投融资服务",
                    meta: { menuShow: true }
                },
                {
                    path: "/fufangyun",
                    component: fufangyun,
                    name: "复方云",
                    meta: { menuShow: true }
                },
                {
                    path: "/chuangxin",
                    component: chuangxin,
                    name: "复方云",
                    meta: { menuShow: true }
                }, {
                    path: "/shuzhi",
                    component: shuzhi,
                    name: "复方云",
                    meta: { menuShow: true }
                },

                {
                    path: "/infoindex",
                    component: Infoindex,
                    name: "个人信息",
                    meta: { menuShow: true }
                },
                {
                    path: "/changepswd",
                    component: Changepswd,
                    name: "修改密码",
                    meta: { menuShow: true }
                },

                {
                    path: "/info",
                    component: Info,
                    name: "系统消息",
                    meta: { menuShow: true }
                },
                {
                    path: "/infoproductdetails",
                    component: Infoproductdetails,
                    name: "处方详情",
                    meta: { menuShow: true }
                },
                {
                    path: "/infoproductPublish",
                    component: InfoproductPublish,
                    name: "修改发布处方详情",
                    meta: { menuShow: true }
                },
                {
                    path: "/inforequiresdetails",
                    component: Inforequiresdetails,
                    name: "需求详情",
                    meta: { menuShow: true }
                }, {
                    path: "/inforequiresPublish",
                    component: InforequiresPublish,
                    name: "修改发布需求详情",
                    meta: { menuShow: true }
                },



                {
                    path: "/fuwuliucheng",
                    component: Fuwuliucheng,
                    name: "服务流程",
                    meta: { menuShow: true }
                },

                {
                    path: "/achievementSearch",
                    component: AchievementSearch,
                    name: "中药制剂成果检索",
                    meta: { menuShow: true }
                },
                {
                    path: "/achievementdetails",
                    component: Achievementdetails,
                    name: "中药制剂成果详情",
                    meta: { menuShow: true }
                },
                {
                    path: "/requirement",
                    component: Requirement,
                    name: "成功需求转化",
                    meta: { menuShow: true }
                },
                {
                    path: "/requirement/productpublish",
                    component: ProductPublish,
                    name: "发布产品",
                    meta: { menuShow: true }
                },
                {
                    path: "/requirement/productdetails",
                    component: Productdetails,
                    name: "详情",
                    meta: { menuShow: true }
                },
                {
                    path: "/requirement/productevaluate",
                    component: Productevaluate,
                    name: "已录入处方评估",
                    meta: { menuShow: true }
                },
                {
                    path: "/requirement/productInquiry",
                    component: ProductInquiry,
                    name: "处方询价",
                    meta: { menuShow: true }
                },
                {
                    path: "/requirement/requirespublish",
                    component: RequiresPublish,
                    name: "发布需求",
                    meta: { menuShow: true }
                },
                {
                    path: "/requirement/requiresdetails",
                    component: Requiresdetails,
                    name: "详情",
                    meta: { menuShow: true }
                },
                {
                    path: "/requirement/requiresevaluate",
                    component: Requiresevaluate,
                    name: "已录入处方评估",
                    meta: { menuShow: true }
                },
                {
                    path: "/requirement/requiresInquiry",
                    component: RequiresInquiry,
                    name: "处方询价",
                    meta: { menuShow: true }
                },
                {
                    path: "/drugaudit",
                    component: Drugaudit,
                    name: "药审动态",
                    meta: { menuShow: true }
                },
                {
                    path: "/drugaudit/details",
                    component: Drugauditdetails,
                    name: "药审动态详情",
                    meta: { menuShow: true }
                },

                {
                    path: "/conferenceMessage",
                    component: ConferenceMessage,
                    name: "会议咨询",
                    meta: { menuShow: true }
                },
                {
                    path: "/conferenceMessage/details",
                    component: ConferenceMessagedetails,
                    name: "会议咨询详情",
                    meta: { menuShow: true }
                },

                {
                    path: "/technology",
                    component: Technology,
                    name: "科技前沿",
                    meta: { menuShow: true }
                },
                {
                    path: "/technology/details",
                    component: Technologydetails,
                    name: "科技前沿详情",
                    meta: { menuShow: true }
                },
                {
                    path: "/invest",
                    component: Invest,
                    name: "投融资动态",
                    meta: { menuShow: true }
                },
                {
                    path: "/invest/details",
                    component: Investdetails,
                    name: "投融资详情",
                    meta: { menuShow: true }
                },
                {
                    path: "/requirement/assess",
                    component: Assess,
                    name: "投融资详情",
                    meta: { menuShow: true }
                },
                {
                    path: "/manufacture",
                    component: Manufacture,
                    name: "通用制造",
                    meta: { menuShow: true }
                },
                {
                    path: "/service",
                    component: Service,
                    name: "小试中试服务",
                    meta: { menuShow: true }
                },
                {
                    path: "/yingxiao",
                    component: Yingxiao,
                    name: "营销服务",
                    meta: { menuShow: true }
                },

                // {
                //     path: "/newList",
                //     component: NewList,
                //     name: "需求信息",
                //     meta: { menuShow: true }
                // },
                // {
                //     path: "/demandList",
                //     component: DemandList,
                //     name: "需求信息",
                //     meta: { menuShow: true }
                // },
                // {
                //     path: "/addDemand",
                //     component: AddDemand,
                //     name: "提交需求信息",
                //     meta: { menuShow: true }
                // },
                // {
                //     path: "/filingsList",
                //     component: FilingsList,
                //     name: "院内制剂",
                //     meta: { menuShow: true }
                // },
                // {
                //     path: "/filingsView",
                //     component: FilingsView,
                //     name: "院内制剂详情",
                //     meta: { menuShow: true }
                // },
                // {
                //     path: "/newsView",
                //     component: NewsView,
                //     name: "行业信息详情",
                //     meta: { menuShow: true }
                // }
            ]
        },
        {
            path: "/mobile",
            name: "home",
            component: mobileHome,
            redirect: "/mobile/index",
            leaf: true, // 只有一个节点            
            meta: {
                title: "中药创新研发协作交互中心平台",
                requireAuth: true,
                isTabPage: false,
                isHeaderShow: false
            },
            iconCls: "fa fa-home", // 图标样式class
            children: [
                {
                    path: "/mobile/index",
                    component: mobileIndex,
                    name: "首页",
                    meta: {
                        title: "中药创新研发协作交互中心平台",
                        requireAuth: true,
                        isTabPage: false,
                        isHeaderShow: false
                    }
                },
                {
                    path: "/mobile/login",
                    component: mobileLogin,
                    name: "登录",
                    meta: {
                        title: "登录",
                        requireAuth: true,
                        isTabPage: false,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/forgetpassword",
                    component: mobileForgetpassword,
                    name: "忘记密码",
                    meta: {
                        title: "忘记密码",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/register",
                    component: mobileRegister,
                    name: "注册",
                    meta: {
                        title: "注册",
                        requireAuth: true,
                        isTabPage: false,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/infoindex",
                    component: mobileInfoindex,
                    name: "个人信息",
                    meta: {
                        title: "个人信息",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/changepswd",
                    component: mobileChangepswd,
                    name: "修改密码",
                    meta: {
                        title: "修改密码",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/info",
                    component: mobileInfo,
                    name: "系统消息",
                    meta: {
                        title: "系统消息",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/infoproductdetails",
                    component: mobileInfoproductdetails,
                    name: "处方详情",
                    meta: {
                        title: "处方详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/infoproductPublish",
                    component: mobileInfoproductPublish,
                    name: "修改发布处方详情",
                    meta: {
                        title: "修改发布处方详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/inforequiresdetails",
                    component: mobileInforequiresdetails,
                    name: "需求详情",
                    meta: {
                        title: "需求详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                }, {
                    path: "/mobile/inforequiresPublish",
                    component: mobileInforequiresPublish,
                    name: "修改发布需求详情",
                    meta: {
                        title: "修改发布需求详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/achievementSearch",
                    component: mobileAchievementSearch,
                    name: "中药制剂成果检索",
                    meta: {
                        title: "修改发布需求详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/achievementdetails",
                    component: mobileAchievementdetails,
                    name: "中药制剂成果详情",
                    meta: {
                        title: "中药制剂成果详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/requirement",
                    component: mobileRequirement,
                    name: "成功需求转化",
                    meta: {
                        title: "成功需求转化",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/requirement/productpublish",
                    component: mobileProductPublish,
                    name: "发布产品",
                    meta: {
                        title: "发布产品",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/requirement/productdetails",
                    component: mobileProductdetails,
                    name: "详情",
                    meta: {
                        title: "详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/requirement/productevaluate",
                    component: mobileProductevaluate,
                    name: "已录入处方评估",
                    meta: {
                        title: "已录入处方评估",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/requirement/productInquiry",
                    component: mobileProductInquiry,
                    name: "处方询价",
                    meta: {
                        title: "处方询价",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/requirement/requirespublish",
                    component: mobileRequiresPublish,
                    name: "发布需求",
                    meta: {
                        title: "发布需求",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/requirement/requiresdetails",
                    component: mobileRequiresdetails,
                    name: "详情",
                    meta: {
                        title: "详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/requirement/requiresevaluate",
                    component: mobileRequiresevaluate,
                    name: "已录入处方评估",
                    meta: {
                        title: "已录入处方评估",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/requirement/requiresInquiry",
                    component: mobileRequiresInquiry,
                    name: "处方询价",
                    meta: {
                        title: "处方询价",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/drugaudit",
                    component: mobileDrugaudit,
                    name: "药审动态",
                    meta: {
                        title: "药审动态",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/drugaudit/details",
                    component: mobileDrugauditdetails,
                    name: "药审动态详情",
                    meta: {
                        title: "药审动态详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },

                {
                    path: "/mobile/conferenceMessage",
                    component: mobileConferenceMessage,
                    name: "会议咨询",
                    meta: {
                        title: "会议咨询",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/conferenceMessage/details",
                    component: mobileConferenceMessagedetails,
                    name: "会议咨询详情",
                    meta: {
                        title: "会议咨询详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },

                {
                    path: "/mobile/technology",
                    component: mobileTechnology,
                    name: "科技前沿",
                    meta: {
                        title: "科技前沿",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/technology/details",
                    component: mobileTechnologydetails,
                    name: "科技前沿详情",
                    meta: {
                        title: "科技前沿详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/invest",
                    component: mobileInvest,
                    name: "投融资动态",
                    meta: {
                        title: "投融资动态",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/invest/details",
                    component: mobileInvestdetails,
                    name: "投融资详情",
                    meta: {
                        title: "投融资详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/requirement/assess",
                    component: mobileAssess,
                    name: "投融资详情",
                    meta: {
                        title: "投融资详情",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/manufacture",
                    component: mobileManufacture,
                    name: "通用制造",
                    meta: {
                        title: "通用制造",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/service",
                    component: mobileService,
                    name: "小试中试服务",
                    meta: {
                        title: "小试中试服务",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                },
                {
                    path: "/mobile/yingxiao",
                    component: mobileYingxiao,
                    name: "营销服务",
                    meta: {
                        title: "营销服务",
                        requireAuth: true,
                        isTabPage: true,
                        isHeaderShow: true
                    }
                }
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.meta) {
        let tit = to.meta.title ? to.meta.title : require("../../config/index").title;
        storeself.commit("title/SET_TITLE", tit);

        // 404页面
        if (to.name == "page404") {
            next();
            return false;
        }
        //storeself.commit("layout/SET_IS_HEADER_SHOW", true);
        /* 判断是否显示底部导航 */
        let isTabPage = to.meta.isTabPage;
        if (isTabPage === true) {
            storeself.commit("layout/SET_IS_FOOTER_SHOW", true);
        } else {
            storeself.commit("layout/SET_IS_FOOTER_SHOW", false);
        }
        let isHeaderShow = to.meta.isHeaderShow;
        if (isHeaderShow === true) {
            storeself.commit("layout/SET_IS_HEADER_SHOW", true);
        } else {
            storeself.commit("layout/SET_IS_HEADER_SHOW", false);
        }
    }
    next();
});
router.afterEach((to, from, next) => {

    window.scrollTo(0, 0);
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js